import { render, staticRenderFns } from "./TabFilterGenre.vue?vue&type=template&id=ce56b322&scoped=true&"
import script from "./TabFilterGenre.vue?vue&type=script&lang=coffee&"
export * from "./TabFilterGenre.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce56b322",
  null
  
)

export default component.exports